<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <b-card class="mb-0">
        <!-- logo -->
        <b-link class="brand-logo">
          <b-img
            height="35"
              :src="appLogo"
              alt="logo"
            />
        </b-link>

        <b-card-title class="mb-1"> Verify Email Address </b-card-title>
        <b-card-text class="mb-2">
          Please enter the code sent your email address.
        <br>
        <small>If you don’t see the email within a few minutes, please check your spam folder.</small>
        </b-card-text>
        <b-alert :show="!!errorMessage" variant="danger">
          {{ errorMessage }}
        </b-alert>

        <!-- form -->
        <validation-observer ref="simpleRules">
          <b-form method="POST" class="mt-2" @submit.prevent="validationForm">
            <b-form-group label="Token" label-for="code">
              <validation-provider
                #default="{ errors }"
                name="Code"
                vid="Code"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="code"
                    v-model="code"
                    type="number"
                    :state="errors.length > 0 ? false : null"
                    class="form-control-merge"
                    name="code"
                    placeholder="code"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button variant="primary" type="submit" block>
              Verify Token
            </b-button>
          </b-form>
        </validation-observer>
      </b-card>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BCard,
  BCardTitle,
  BCardText,
  BForm,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BImg,
  BLink,
  BFormInput,
  BButton,
  BAlert,
} from "bootstrap-vue";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";
import { $themeConfig } from '@themeConfig';
export default {
  components: {
    BAlert,
    BCard,
    BButton,
    BCardTitle,
    BCardText,
    BForm,
    BFormGroup,
    BInputGroup,
    BImg,
    BLink,
    BFormInput,
    //BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    appLogo(){
      const {appLogoImage } = $themeConfig.app
      return appLogoImage;
    },
  },
  data() {
    return {
      code: "",
      // validation
      required,
      errorMessage: "",
    };
  },
  mounted() {
    const code = this.$route.params.code;
    if (undefined !== code) {
      useJwt
        .verifyAccount(code)
        .then((response) => {
          this.$store.commit("account/SET_VERIFY_CODE_RESPONSE", response.data);
          this.$router.replace({ name: "set-password" });
          //console.log(this.$store.state.account.verifyTokenResponse);
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.response.data.error,
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.$router.replace({ name: "auth-login" });
        });
    }
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          useJwt
            .verifyAccount(this.code)
            .then((response) => {
              this.$store.commit(
                "account/SET_VERIFY_CODE_RESPONSE",
                response.data
              );
              this.$router.replace({ name: "set-password" });
              //console.log(this.$store.state.account.verifyTokenResponse);
            })
            .catch((error) => {
              this.errorMessage = error.message;
              console.log(error);
            });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
